import { render, staticRenderFns } from "./FormularioCancelamento.vue?vue&type=template&id=a68dc612&scoped=true&"
import script from "./FormularioCancelamento.vue?vue&type=script&lang=js&"
export * from "./FormularioCancelamento.vue?vue&type=script&lang=js&"
import style0 from "./FormularioCancelamento.vue?vue&type=style&index=0&id=a68dc612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68dc612",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a68dc612')) {
      api.createRecord('a68dc612', component.options)
    } else {
      api.reload('a68dc612', component.options)
    }
    module.hot.accept("./FormularioCancelamento.vue?vue&type=template&id=a68dc612&scoped=true&", function () {
      api.rerender('a68dc612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Perfil/components/FormularioCancelamento.vue"
export default component.exports